import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useEntityHistoryCardStyles = makeStyles((theme) => ({
  card: {
    minHeight: '200px',
    maxWidth: '900px',
    background: `linear-gradient(to bottom, #fff, #EDF0F7 350px)`,
    [theme.breakpoints.down('md')]: {
      marginTop: 0
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    borderBottom: `1px solid ${Colors.lightGray}`
  },
  body: {
    padding: '0 2rem 2rem',
    [theme.breakpoints.down('md')]: {
      padding: '0 16px 16px'
    }
  },
  groups: {
    padding: '8px 0'
  },
  empty: {
    textAlign: 'center',
    padding: '32px 0',
    color: Colors.midGray,
    fontSize: '14px'
  },
  buttonWrapper: {
    textAlign: 'center',
    padding: '12px 0'
  },
  button: {
    color: Colors.timelineGray,
    borderColor: Colors.timelineGray
  }
}));
